import { useVideosList } from 'lib/hooks/queries/video/useVideosList';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import Modal from './components/Modal';
import { DEFAULT_COLUMNS } from './lib/helpers';

const Videos = () => {
  return (
    <AgTablePage
      ModalComponent={Modal}
      useData={useVideosList}
      name="videos"
      onSelectRow={() => {}}
      defaultColumns={DEFAULT_COLUMNS}
      defaultFilters={[]}
      queryParams={{ withCount: true }}
    />
  );
};

export default Videos;
